export type SearchTab = "products" | "articles" | "pages" | "categories";

export interface SearchTabCounts {
	products?: number;
	articles?: number;
	pages?: number;
	categories?: number;
	isLoadingProducts?: boolean;
}

export const getActiveTab = (
	requestedTab: SearchTab | null,
	counts?: SearchTabCounts,
): SearchTab => {
	if (requestedTab) {
		return requestedTab;
	}

	if (counts?.isLoadingProducts) return "products";
	if ((counts?.products ?? 0) > 0) return "products";
	if ((counts?.articles ?? 0) > 0) return "articles";
	if ((counts?.pages ?? 0) > 0) return "pages";
	if ((counts?.categories ?? 0) > 0) return "categories";
	return "products";
};
